<template>
    <v-card-text class="mt-4">
        <v-row class="centrado">
            <v-flex xs12>
                <v-img
                        class="centrado ml-4 mr-4"
                        :src="require('../assets/intLogo.png')"
                        height="250px"
                        contain
                ></v-img>
            </v-flex>
            <div class="
                text-xs-center
                text-sm-center
                text-md-center
                text-lg-center
                text-xl-center">
                <br>
                <h2>{{$t('identidad_desconocido')}}</h2>
                <h2>{{$t('identidad_desconocido2')}}</h2>
                <br>
                <v-btn color="primary" to="/">{{ $t('inicio')}}</v-btn>
            </div>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        name: "confirmar_desconocido"
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
